import type { AxiosRequestConfig } from 'axios'
import { api } from './client'
import { getCsrfToken } from './utils'

interface BeaconWindow extends Window {
  Beacon?: { captureError: (error: unknown) => void }
}

let isRedirecting = false

api.interceptors.request.use((config) => {
  if (['post', 'put', 'patch', 'delete'].includes(config.method ?? '')) {
    const csrf = getCsrfToken()
    if (csrf) config.headers['X-XSRF-TOKEN'] = csrf
  }
  return config
})

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    // 419 = CSRF token mismatch — common after deploys when the XSRF-TOKEN
    // cookie is stale. Re-fetch the cookie from Sanctum and retry once.
    if (error.response?.status === 419 && !(error.config as AxiosRequestConfig & { _csrfRetried?: boolean })._csrfRetried) {
      try {
        await api.get('/sanctum/csrf-cookie')
        ;(error.config as AxiosRequestConfig & { _csrfRetried?: boolean })._csrfRetried = true
        return api(error.config)
      } catch {
        // Cookie refresh failed — fall through to normal error handling
      }
    }

    if (error.response?.status === 401 && !isRedirecting) {
      isRedirecting = true
      localStorage.removeItem('user')
      localStorage.removeItem('workspace')
      window.location.href = '/login'
      setTimeout(() => { isRedirecting = false }, 3000)
    }

    if (error.response?.status === 403) {
      console.warn('[Beacon] Access forbidden:', error.response.data?.message)
    }

    if (error.response?.status >= 500) {
      ;(window as BeaconWindow).Beacon?.captureError(error)
    }

    return Promise.reject(error)
  },
)

export default api
